import apiClient from "./client";
import type { GetIconsParams, IconsListResponse } from "../types/icon";

export const getIcons = async (
  params: GetIconsParams
): Promise<IconsListResponse> => {
  const { data } = await apiClient.get<IconsListResponse>("/icons", {
    params: {
      m_tenant_id: params.m_tenant_id,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
